// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
import amplitude from 'amplitude-js';
const QuotesApi = ApiFactory.get('quotes');

const fetchAll = async ({ commit, getters, dispatch }, qs) => {
  const { data } = await QuotesApi.getAll(qs);
  if (getters.getLength && getters.getLength < data.length) {
    await dispatch('stops/fetchAll', qs, { root: true });
    await dispatch('dates/fetchAll', qs.replace('trip__', ''), { root: true });
    getters.last(data.length - getters.getLength).forEach(quote => {
      const message = `New Quote: ${quote.trip.trip_id}`;
      const link = `/quotes/${quote.id}`;
      dispatch('app/addNotification', { message, link }, { root: true });
    });
  }
  commit('SET_DATA', data);
  commit('SET_LENGTH', data.length);
  commit('SET_BOOKED', data.filter(quote => quote.trip.booked === true).length);
  commit('SET_COMPLETED', data.filter(quote => quote.trip.completed === true).length);
  commit('SET_UPDATED', new Date());
  return data;
};

const update = async ( { commit }, payload ) => {
  const { data } = await QuotesApi.update(payload.id, payload);
  amplitude.getInstance().logEvent('UPDATE_QUOTE')
  commit("UPDATE_BY_ID", data, payload.id);
  commit('SET_UPDATED', new Date());
};

export default {
  fetchAll,
  update
};
